module.exports = __webpack_public_path__ + "static/media/dark-modulo-pesquisa.7ebd775c.svg";